import http from '../core/http-common'
import { IBlockType } from '../types/BlockType'
import { OccupancyFilterRequest } from '../types/FloorType'

class BlockService {
  GetAuthBlockList(locationId: number, occupancyDate: string, myFirm: boolean) {
    return http.get<IBlockType[]>(
      `/Block/GetAuthBlockList?locationId=${locationId}&occupancyDate=${occupancyDate}&myFirm=${myFirm}`
    )
  }

  GetBlockOccupancy(request: OccupancyFilterRequest) {
    return http.post<any>('/Block/GetBlockOccupancy', request)
  }
}

const blockService = new BlockService()
export default blockService
